import { useState, useEffect } from 'react';

type CookiePreferences = {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
};

const defaultPreferences: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export const useCookieConsent = () => {
  const [preferences, setPreferences] = useState<CookiePreferences>(defaultPreferences);
  
  useEffect(() => {
    // Load preferences from localStorage on mount
    const loadPreferences = () => {
      try {
        const savedPreferences = localStorage.getItem('cookieConsent');
        if (savedPreferences) {
          setPreferences(JSON.parse(savedPreferences));
        }
      } catch (error) {
        console.error('Error loading cookie preferences:', error);
      }
    };
    
    // Initial load
    loadPreferences();
    
    // Set up listener for changes
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'cookieConsent' && e.newValue) {
        try {
          setPreferences(JSON.parse(e.newValue));
        } catch (error) {
          console.error('Error parsing updated cookie preferences:', error);
        }
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  // Function to open the cookie consent banner
  const openCookieConsent = () => {
    window.dispatchEvent(new CustomEvent('openCookieConsent'));
  };
  
  return {
    preferences,
    isAllowed: (type: keyof CookiePreferences) => {
      if (type === 'necessary') return true; // Always allow necessary cookies
      return preferences[type] === true;
    },
    openCookieConsent,
  };
}; 